import { useState, createContext, useEffect, useContext } from "react";
import { getStateList, getPartyList, getMappinList, getCountryList, getIrelandStateList } from "apis/common/data";
import { AuthContext } from "./AuthContext";

export const DataContext = createContext();

export const DataProvider = (props) => {

  const [stateList, setStateList] = useState([]);
  const [irelandStateList, setIrelandStateList] = useState([]);
  const [partyList, setPartyList] = useState([]);
  const [mappingTable, setMappingTable] = useState([]);
  const [stateMapping, setStateMapping] = useState([]);
  const [youTubeData, setYouTubeData] = useState([]);
  const [twitterDataMedia, setTwitterDataMedia] = useState([]);
  const [twitterDataBjp, setTwitterDataBjp] = useState([]);
  const [twitterDataNonBjp, setTwitterDataNonBjp] = useState([]);
  const [countryList,setCountryList]=useState([])
  const { isLoggedIn } = useContext(AuthContext);

  // const [youTubeState, setYouTubeState] = useState({
  //   top: false,
  // });

  const getStateData = async (id=50) => {
    const { result, err } = await getStateList(id);
    if (err) {
      alert("Couldn't fetch the data");
      return;
    }
    setStateList(result);
  };
  const getIrelandStateData = async () => {
    const { result, err } = await getIrelandStateList();
    if (err) {
      alert("Couldn't fetch the data");
      return;
    }
    setIrelandStateList(result);
  };
  const getCountryData = async () => {
    const { result, err } = await getCountryList();
    if (err) {
      alert("Couldn't fetch the data");
      return;
    }
    setCountryList(result);
  };

  const getPartyData = async () => {
    const { result, err } = await getPartyList();
    if (err) {
      alert("Couldn't fetch the data");
      return;
    }
    setPartyList(result);
  };

  const getMappingTable = async () => {
    const { result, err } = await getMappinList();
    if (err) {
      alert("Couldn't fetch the data");
      return;
    }
    setMappingTable(result);
    const stateMappingValue = result.filter((val) => val.name.toLowerCase() === "state");
    setStateMapping(stateMappingValue)
  };

  useEffect(() => {
    if(isLoggedIn){
      getStateData();
      getPartyData();
      getMappingTable();
      getCountryData();
      getIrelandStateData();
    }
      

  }, [isLoggedIn]);
  useEffect(() => {
    if (countryList.length) {
      getStateData(countryList[0].id);
    }
  }, [countryList]);
  const state = {
    stateList,
    irelandStateList,
    partyList,
    countryList,
    mappingTable,
    stateMapping,
    youTubeData,
    twitterDataMedia,
    twitterDataBjp,
    twitterDataNonBjp,
    // youTubeState,
  };

  return (
    <DataContext.Provider
      value={{
        stateList: state.stateList,
        irelandStateList:state.irelandStateList,
        partyList: state.partyList,
        countryList:state.countryList,
        mappingTable: state.mappingTable,
        stateMapping: state.stateMapping,
        youTubeData: state.youTubeData,
        twitterDataMedia: state.twitterDataMedia,
        twitterDataBjp: state.twitterDataBjp,
        twitterDataNonBjp: state.twitterDataNonBjp,
        // youTubeState: state.youTubeState,
        setYouTubeData,
        setTwitterDataMedia,
        setTwitterDataBjp,
        setTwitterDataNonBjp,
      }}
    >
      {props.children}
    </DataContext.Provider>
  );
};